import { useEffect, useState } from 'react';
import API from '../../api';
import { useToast } from '../../context/ToastContext';
import { useConfirm } from '../../context/ConfirmContext';
import SearchSelect from '../../components/SearchSelect';

export default function EnseignantQCM() {
  const [evals, setEvals] = useState([]);
  const [selectedEval, setSelectedEval] = useState('');
  const [questions, setQuestions] = useState([]);
  const [form, setForm] = useState({
    enonce: '', choix_a: '', choix_b: '', choix_c: '', choix_d: '', bonne_reponse: 'A', ordre: 0,
  });
  const [editId, setEditId] = useState(null);
  const { addToast } = useToast();
  const confirm = useConfirm();

  useEffect(() => {
    API.get('evaluations/?type_eval=QCM').then((r) => setEvals(r.data.results || r.data));
  }, []);

  useEffect(() => {
    if (selectedEval) {
      API.get(`questions-qcm/?evaluation=${selectedEval}`)
        .then((r) => setQuestions(r.data.results || r.data));
    } else {
      setQuestions([]);
    }
  }, [selectedEval]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...form, evaluation: selectedEval, ordre: parseInt(form.ordre) };
      if (editId) { await API.put(`questions-qcm/${editId}/`, payload); addToast('Question modifiée', 'success'); }
      else { await API.post('questions-qcm/', payload); addToast('Question ajoutée', 'success'); }
      setForm({ enonce: '', choix_a: '', choix_b: '', choix_c: '', choix_d: '', bonne_reponse: 'A', ordre: 0 });
      setEditId(null);
      const r = await API.get(`questions-qcm/?evaluation=${selectedEval}`);
      setQuestions(r.data.results || r.data);
    } catch { addToast('Erreur lors de l\'opération', 'error'); }
  };

  const handleEdit = (q) => {
    setEditId(q.id);
    setForm({
      enonce: q.enonce, choix_a: q.choix_a, choix_b: q.choix_b,
      choix_c: q.choix_c || '', choix_d: q.choix_d || '',
      bonne_reponse: q.bonne_reponse, ordre: q.ordre,
    });
  };

  const handleDelete = async (id) => {
    if (await confirm('Supprimer cette question ?')) {
      await API.delete(`questions-qcm/${id}/`);
      addToast('Question supprimée', 'info');
      const r = await API.get(`questions-qcm/?evaluation=${selectedEval}`);
      setQuestions(r.data.results || r.data);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-patch-question" /> Gestion des Questions QCM</h2>
      </div>

      <SearchSelect
        className="select-filter-wrap"
        value={selectedEval}
        onChange={(e) => setSelectedEval(e.target.value)}
        options={evals.map((ev) => ({ value: ev.id, label: `${ev.titre} (${ev.cours_titre})` }))}
        placeholder="-- Sélectionner une évaluation QCM --"
      />

      {selectedEval && (
        <>
          <div className="form-glass">
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group full-width">
                  <label>Énoncé de la question</label>
                  <textarea className="form-control" name="enonce" placeholder="Saisissez l'énoncé..." value={form.enonce} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label>Choix A</label>
                  <input className="form-control" name="choix_a" placeholder="Choix A" value={form.choix_a} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label>Choix B</label>
                  <input className="form-control" name="choix_b" placeholder="Choix B" value={form.choix_b} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label>Choix C</label>
                  <input className="form-control" name="choix_c" placeholder="Choix C (optionnel)" value={form.choix_c} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Choix D</label>
                  <input className="form-control" name="choix_d" placeholder="Choix D (optionnel)" value={form.choix_d} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Bonne réponse</label>
                  <select className="form-control" name="bonne_reponse" value={form.bonne_reponse} onChange={handleChange}>
                    <option value="A">A</option><option value="B">B</option>
                    <option value="C">C</option><option value="D">D</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Ordre</label>
                  <input className="form-control" name="ordre" type="number" placeholder="0" value={form.ordre} onChange={handleChange} />
                </div>
              </div>
              <div className="form-actions">
                <button type="submit" className="btn btn-primary">
                  <i className={editId ? 'bi bi-check-lg' : 'bi bi-plus-lg'} /> {editId ? 'Modifier' : 'Ajouter'}
                </button>
                {editId && (
                  <button type="button" className="btn btn-secondary" onClick={() => { setEditId(null); setForm({ enonce: '', choix_a: '', choix_b: '', choix_c: '', choix_d: '', bonne_reponse: 'A', ordre: 0 }); }}>
                    <i className="bi bi-x-lg" /> Annuler
                  </button>
                )}
              </div>
            </form>
          </div>

          <div className="data-table-wrapper">
            <table className="data-table">
              <thead>
                <tr><th>#</th><th>Énoncé</th><th>A</th><th>B</th><th>C</th><th>D</th><th>Réponse</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {questions.length === 0 ? (
                  <tr><td colSpan="8"><div className="empty-state"><i className="bi bi-patch-question" /><p>Aucune question</p></div></td></tr>
                ) : questions.map((q) => (
                  <tr key={q.id}>
                    <td>{q.ordre}</td>
                    <td>{q.enonce.substring(0, 60)}…</td>
                    <td>{q.choix_a}</td><td>{q.choix_b}</td>
                    <td>{q.choix_c || '–'}</td><td>{q.choix_d || '–'}</td>
                    <td><span className="badge-type badge-qcm">{q.bonne_reponse}</span></td>
                    <td>
                    <button className="btn btn-sm btn-secondary" onClick={() => handleEdit(q)}><i className="bi bi-pencil" /></button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(q.id)}><i className="bi bi-trash" /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
